export const MARKETING_CONSENT_KEY = "thecoach_marketing_consent";
export const MARKETING_CONSENT_EVENT = "thecoach:marketing-consent";

export type MarketingConsent = "granted" | "denied" | null;

export function readMarketingConsent(): MarketingConsent {
  if (typeof window === "undefined") return null;
  const value = window.localStorage.getItem(MARKETING_CONSENT_KEY);
  return value === "granted" || value === "denied" ? value : null;
}

export function saveMarketingConsent(value: Exclude<MarketingConsent, null>) {
  window.localStorage.setItem(MARKETING_CONSENT_KEY, value);
  window.dispatchEvent(
    new CustomEvent(MARKETING_CONSENT_EVENT, { detail: value }),
  );
}
